(function () {
  'use strict';
  if (window.PSTStorefrontMotion) return;
  var preference = matchMedia('(prefers-reduced-motion: reduce)');
  var seen = new WeakSet();
  var active = new Set();
  function enter(element, delay) {
    if (preference.matches || !element.animate || element.closest('[hidden], dialog, .ps-drawer, .ps-kinetic, [data-livery-carousel]')) return;
    var animation = element.animate([
      { opacity: 0.5, transform: 'translateY(10px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 420, delay: delay || 0, easing: 'cubic-bezier(.2,.7,.2,1)' });
    active.add(animation);
    animation.onfinish = animation.oncancel = function () { active.delete(animation); };
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    var step = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      enter(entry.target, Math.min(step++ * 45, 135));
    });
  }, { threshold: 0.12 }) : null;
  function init(root) {
    root.querySelectorAll('.ps-pcard, .ps-section-head, .ps-coll-head h1, .ps-page-intro h1, .ps-custom-work__intro, .ps-reveal, [data-pst-motion]').forEach(function (element) {
      if (seen.has(element) || element.parentElement.closest('.ps-reveal')) return;
      seen.add(element);
      if (observer) observer.observe(element);
    });
    root.querySelectorAll('details').forEach(function (details) {
      if (seen.has(details)) return;
      seen.add(details);
      details.addEventListener('toggle', function () {
        if (details.open) Array.from(details.children).filter(function (child) { return child.tagName !== 'SUMMARY'; }).forEach(function (child) { enter(child, 0); });
      });
    });
  }
  preference.addEventListener('change', function () {
    if (preference.matches) active.forEach(function (animation) { animation.cancel(); });
  });
  function start() { init(document); }
  window.PSTStorefrontMotion = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.ps-accordion__btn[aria-controls]');
    if (!button) return;
    requestAnimationFrame(function () {
      if (button.getAttribute('aria-expanded') !== 'true') return;
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) enter(panel, 0);
    });
  });
}());
